import React from "react";
import { Helmet } from "react-helmet";

const CommitteeLink = ({ title, link, showBadge = true }) => (
	<div className="StatutoryLinkWrapper" style={{ marginBottom: "10px", width: "100%" }}>
		<a className="lbox" href={link} target="_blank" rel="noreferrer" style={{ width: "100%", textAlign: "left", display: "flex", justifyContent: "space-between", alignItems: "center", textDecoration: "none", boxSizing: "border-box" }}>
			<span style={{ fontWeight: "600" }}>{title} – Click Here</span>
			{showBadge && <span style={{ fontSize: "0.8rem", background: "var(--primary-color)", color: "white", padding: "2px 8px", borderRadius: "4px" }}>PDF</span>}
		</a>
	</div>
);

const MemberTable = ({ members }) => (
	<div className="table-responsive" style={{ marginBottom: "20px", overflowX: "auto" }}>
		<table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
			<thead style={{ background: "var(--primary-color)", color: "white" }}>
				<tr>
					<th style={{ padding: "12px", textAlign: "left", border: "1px solid #ddd" }}>Name</th>
					<th style={{ padding: "12px", textAlign: "left", border: "1px solid #ddd" }}>Role in Committee</th>
					<th style={{ padding: "12px", textAlign: "left", border: "1px solid #ddd" }}>Designation</th>
				</tr>
			</thead>
			<tbody>
				{members && members.length > 0 ? (
					members.map((member, index) => (
						<tr key={index}>
							<td style={{ padding: "10px", border: "1px solid #ddd" }}>{member.name}</td>
							<td style={{ padding: "10px", border: "1px solid #ddd" }}>{member.roleInCommittee}</td>
							<td style={{ padding: "10px", border: "1px solid #ddd" }}>{member.designation}</td>
						</tr>
					))
				) : (
					<tr>
						<td colSpan="3" style={{ padding: "15px", textAlign: "center", border: "1px solid #ddd", color: "#888" }}>Data Updating Soon</td>
					</tr>
				)}
			</tbody>
		</table>
	</div>
);

const CommitteeSection = ({ id, title, subtitle, links, members, hasTable, galleries }) => {
	const [openGalleryIdx, setOpenGalleryIdx] = React.useState(null);
	const [selectedImage, setSelectedImage] = React.useState(null);

  return (
    <div id={title.toLowerCase().replace(/\s+/g, '-')} className="CommitteeBlock" style={{ marginBottom: "40px", background: "#fcfcfc", padding: window.innerWidth < 769 ? "15px" : "20px", borderRadius: "8px", border: "1px solid #eee" }} data-aos="fade-up">
			<h2 style={{ color: "var(--primary-color)", borderBottom: "2px solid var(--secondary-color)", paddingBottom: "8px", marginBottom: "15px", fontSize: window.innerWidth < 769 ? "1.2rem" : "1.5rem" }}>{id}. {title}</h2>
			{subtitle && <h4 style={{ marginBottom: "15px", color: "#666", fontSize: "1.1rem" }}>{subtitle}</h4>}
			
			{hasTable && <MemberTable members={members} />}

			<div className="LinksContainer" style={{ display: "flex", flexDirection: "column", gap: "0" }}>
				{links.regulations && <CommitteeLink title={links.regulationsTitle || "Regulations"} link={links.regulations} />}
				{links.formationOrder && <CommitteeLink title={links.formationOrderTitle || "Committee Formation Order"} link={links.formationOrder} />}
				{links.complaints && <CommitteeLink title="For Complaints" link={links.complaints} showBadge={false} />}
			</div>

			{galleries && galleries.length > 0 && (
				<div className="GalleriesContainer" style={{ marginTop: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
					{galleries.map((gallery, idx) => (
						<div key={idx} className="GalleryAccordion">
							<button 
								onClick={() => setOpenGalleryIdx(openGalleryIdx === idx ? null : idx)}
								style={{ 
									background: openGalleryIdx === idx ? "var(--secondary-color)" : "var(--primary-color)", 
									color: "white", 
									border: "none", 
									padding: "12px 20px", 
									borderRadius: "5px", 
									cursor: "pointer",
									fontWeight: "600",
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
									width: window.innerWidth < 769 ? "100%" : "max-content",
									minWidth: window.innerWidth < 769 ? "100%" : "200px",
									gap: "10px",
									transition: "0.3s"
								}}
							>
								{gallery.title}
								<span style={{ transform: openGalleryIdx === idx ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }}>▼</span>
							</button>

							{openGalleryIdx === idx && (
								<div className="ImageGrid" style={{ 
									display: "grid", 
									gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", 
									gap: "10px", 
									marginTop: "20px",
									animation: "fadeIn 0.5s ease"
								}}>
									{gallery.images.map((img, imgIdx) => (
										<div 
											key={imgIdx} 
											className="GalleryItem" 
											onClick={() => setSelectedImage(img)}
											style={{ overflow: "hidden", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", cursor: "zoom-in" }}
										>
											<img 
												src={img} 
												alt={`${gallery.title} ${imgIdx + 1}`} 
												style={{ width: "100%", height: window.innerWidth < 769 ? "120px" : "150px", objectFit: "cover", display: "block", transition: "transform 0.3s" }}
												onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.05)"}
												onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
											/>
										</div>
									))}
								</div>
							)}
						</div>
					))}
				</div>
			)}

			{/* Image Modal */}
			{selectedImage && (
				<div 
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						backgroundColor: 'rgba(0,0,0,0.95)',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						zIndex: 99999999,
						cursor: 'zoom-out',
						padding: '20px'
					}}
					onClick={() => setSelectedImage(null)}
				>
					<span 
						style={{
							position: 'absolute',
							top: '20px',
							right: '20px',
							color: 'white',
							fontSize: '40px',
							fontWeight: 'bold',
							cursor: 'pointer',
							zIndex: 10
						}}
						onClick={() => setSelectedImage(null)}
					>
						&times;
					</span>
					<img 
						src={selectedImage} 
						alt="Full view" 
						style={{ 
							maxWidth: '100%', 
							maxHeight: '100%', 
							objectFit: 'contain',
							borderRadius: '4px',
							boxShadow: '0 0 20px rgba(255,255,255,0.1)',
							animation: 'fadeIn 0.3s ease'
						}} 
					/>
				</div>
			)}
		</div>
	);
};

function AICTEStatutoryCommittees() {
	React.useEffect(() => {
		const hash = window.location.hash;
		if (hash) {
			const hashParts = hash.split('#');
			if (hashParts.length > 2) {
				const id = hashParts[2];
				const element = document.getElementById(id);
				if (element) {
					setTimeout(() => {
						element.scrollIntoView({ behavior: "smooth" });
					}, 500);
				}
			}
		}
	}, []);

	const committees = [
		{
			id: 1,
			title: "Anti Ragging Committee",
			subtitle: "Including Anti-Ragging Squad",
			hasTable: true,
			members: [
				{ name: "Dr. A.K. Saha", roleInCommittee: "Coordinator", designation: "Director" },
				{ name: "Dr. Manish Kumar", roleInCommittee: "Member", designation: "Assistant Professor" },
				{ name: "Mrs. Manisha Baxla", roleInCommittee: "Member", designation: "Assistant Professor" },
				{ name: "Mr. Rajeev Kumar", roleInCommittee: "Member", designation: "Faculty Member" }
			],
			links: {
				regulations: "/docs/antiragging cell.pdf",
				formationOrder: "/docs/antiragging cell.pdf",
				complaints: "/#/complaint"
			}
		},
		{
			id: 2,
			title: "SC ST Committee",
			hasTable: false,
			links: {
				regulations: "https://www.vbu.ac.in/ftpwebapps/vbu/resources/vbu_web/dept/vbu/sc_st_cell.jpg",
				formationOrder: "https://www.vbu.ac.in/ftpwebapps/vbu/resources/vbu_web/dept/vbu/sc_st_cell.jpg",
				complaints: "/#/complaint"
			}
		},
		{
			id: 3,
			title: "Internal Complaint Committee (ICC)",
			hasTable: false,
			links: {
				regulations: "/docs/iic committee.pdf",
				formationOrder: "/docs/iic committee.pdf",
				complaints: "/#/complaint"
			}
		},
		{
			id: 4,
			title: "Grievances & Redressal Committee (SGRC)",
			hasTable: true,
			members: [
				{ name: "Dr. Ashish Kumar Saha", roleInCommittee: "Chairman", designation: "Director" },
				{ name: "Dr. Santosh Kumar Srivastava", roleInCommittee: "Member", designation: "Asst. Professor" },
				{ name: "Mrs. Manisha Baxla", roleInCommittee: "Member", designation: "Asst. Professor" },
				{ name: "Mr. Naveen Kumar", roleInCommittee: "Member", designation: "Student" },
				{ name: "Miss Neha Kumari", roleInCommittee: "Member", designation: "Student" }
			],
			links: {
				regulations: "/docs/grievance.pdf",
				formationOrder: "/docs/grievance.pdf",
				complaints: "/#/complaint"
			}
		},
		{
			id: 5,
			title: "Student Counselors Committee",
			hasTable: false,
			links: {
				regulations: "/docs/student counselor 2024.pdf",
				regulationsTitle: "Committee 2024",
				formationOrder: "/docs/student counselor 2025.pdf",
				formationOrderTitle: "Committee 2025"
			}
		},
		{
			id: 6,
			title: "Institution's Innovation Council (IIC)",
			hasTable: false,
			links: {
				regulations: "/docs/iic cell.pdf",
				regulationsTitle: "IIC Cell",
				formationOrder: "/docs/iic committee.pdf",
				formationOrderTitle: "IIC Committee"
			},
			galleries: [
				{
					title: "View IIC Activity 1",
					images: [
						"/Images/IIC/1.jpeg",
						"/Images/IIC/2.jpeg",
						"/Images/IIC/3.jpeg",
						"/Images/IIC/4.jpeg",
						"/Images/IIC/5.jpeg",
						"/Images/IIC/6.jpeg",
						"/Images/IIC/7.jpeg",
						"/Images/IIC/8.jpeg",
						"/Images/IIC/9.jpeg"
					]
				},
				{
					title: "View IIC Activity 2",
					images: [
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.37.jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.38.jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.38 (1).jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.39.jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.39 (1).jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.39 (2).jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.40.jpeg",
						"/Images/IIC/WhatsApp Image 2026-04-16 at 12.06.40 (1).jpeg"
					]
				}
			]
		}
	];

	return (
		<>
			<Helmet>
				<title>AICTE Statutory Committees - VBU MCA</title>
			</Helmet>
			<div className="PageContainer">
				<div id="Heading">
					<h1>AICTE Statutory Committees</h1>
				</div>
				<p style={{ marginBottom: "30px", fontSize: "1rem", lineHeight: "1.5", color: "#555" }}>
					In compliance with AICTE regulations for technical institutions, the University Department of Computer Applications (VBU MCA) has established the following statutory committees.
				</p>
				
				<div className="AICTECommitteesList">
					{committees.map((committee) => (
						<CommitteeSection 
							key={committee.id}
							id={committee.id}
							title={committee.title}
							subtitle={committee.subtitle}
							links={committee.links}
							members={committee.members}
							hasTable={committee.hasTable}
							galleries={committee.galleries}
						/>
					))}
				</div>
			</div>
		</>
	);
}

export default AICTEStatutoryCommittees;
